import { render, staticRenderFns } from "./EvidencedDocument.vue?vue&type=template&id=92d72bb2&"
import script from "./EvidencedDocument.vue?vue&type=script&lang=ts&"
export * from "./EvidencedDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports